let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d6E0W")).then(() => parcelRequire('arNqo'));